<script setup lang="ts">
import { Property, PropertySchema } from "~/classes/entity"

const props = defineProps({
  files: null
})
const linkMetadata = computed(() => mapped(props.files, f => f.linkMetadata()))

function anyProperty(
  field: keyof FileLinkOpenGraphMetadata,
) {
  return any(Object.values(linkMetadata.value), metadata => metadata?.[field])
}

function stringProperty(
  field: keyof FileLinkOpenGraphMetadata,
): Record<string, EntityPropertyValue | undefined> {
  return mapped(linkMetadata.value, (metadata) => {
    if (metadata && field in metadata)
      return { type: PropertySchema.AnyStringValue, anyString: metadata[field] as any }
  })
}

function numberProperty(
  field: keyof FileLinkOpenGraphMetadata,
): Record<string, EntityPropertyValue | undefined> {
  return mapped(linkMetadata.value, (metadata) => {
    if (metadata && field in metadata)
      return { type: PropertySchema.AnyIntegerValue, anyInteger: metadata[field] as any }
  })
}

function isSingleMultilineField(
  field: keyof FileLinkOpenGraphMetadata,
) {
  if (len(linkMetadata.value) > 1)
    return false
  const value = first(linkMetadata.value)?.[field] ?? ""
  if (typeof value === "string")
    return len(value) > 24
  else return len(JSON.stringify(value)) > 24
}
</script>

<template>
  <panel-details-property-section class="section">
    <template #header>
      Link Details
    </template>
    <panel-details-property-field
      :multiline="true"
      :values="mapped(files, f => f.property(Property.LINK_DESTINATION_URL)?.value)"
      label="URL"
    />
    <panel-details-property-field
      v-if="anyProperty('title')"
      :multiline="isSingleMultilineField('title')"
      :values="stringProperty('title')"
      label="Title"
    />
    <panel-details-property-field
      v-if="anyProperty('description')"
      :multiline="isSingleMultilineField('description')"
      :values="stringProperty('description')"
      label="Description"
    />
    <panel-details-property-field
      v-if="anyProperty('contentType')"
      :multiline="isSingleMultilineField('contentType')"
      :values="numberProperty('contentType')"
      label="Content Type"
    />
  </panel-details-property-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
</style>
